export default{
    section:'بخش',
    medicalAbbreviationTestsTitle: 'Title',
    sectionStatus: 'وضعیت',
    medicalAbbreviationTests:'MedicalAbbreviationTests',
    editMedicalAbbreviationTests:'Edit MedicalAbbreviationTests',
    addMedicalAbbreviationTests:'MedicalAbbreviationTests New',
}